module.exports = __webpack_public_path__ + "img/1-3.d4af3da3.jpg";